import { useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage"
import { CardTaps } from "../../../../theme/Component/CardTaps"
import { SearchRadicate } from "./SearchRadicate";
import { RadicateForm } from "./RadicateForm";

export const DodoPanel=()=>{

    const [taps] = useState([
        { id: 0, name: 'Buscar Radicado' },
        { id: 1, name: 'Radicar',disable:false }
    ]);
    const [indexTap, setIndexTap] = useState(0);

    return(
        <BasicPage titulo="Dodo">
            <div className="row">
                <div className="col">
                    <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                        <div className="row">
                            <div className="col">
                                {indexTap === 0 &&
                                    <SearchRadicate/>
                                }
                                {indexTap === 1 &&
                                    <RadicateForm/>
                                }
                            </div>
                        </div>
                    </CardTaps>
                </div>
            </div>
        </BasicPage>
    )
}